<template>
  <div
    class="text-align-left pj_clearfix"
    v-if="this.$store.get('systems@ApiKey')"
  >
    <b-alert show variant="dark">
      <b-alert show variant="secondary">
        <div v-if="!this.tbTableData">
          <b-badge variant="warning" class="font18px"
            >ไม่พบรายการที่ค้นหา !</b-badge
          >
        </div>
        <div>
          <b-table
            striped
            hover
            small
            :items="this.tbTableData"
            :fields="this.tbTableFieldsData"
            :sort-by.sync="sortBy"
            :sort-asc.sync="sortDesc"
            class="font13px"
            responsive
          >
            <template v-slot:cell(action)="row">
              <div
                style="width:22px;margin:auto;"
                @click="
                  viewDocScans(
                    row.item.hn,
                    row.item.scan_opd_card_type,
                    row.item.scan_opd_card_datetime,
                    row.item.scan_opd_card_file_name
                  )
                "
              >
                <v-icon
                  name="file"
                  class="icon-custom1 cursor-pointer font-color2"
                ></v-icon>
              </div>
            </template>
          </b-table>
        </div>
      </b-alert>
    </b-alert>
  </div>
</template>

<script>
import { Component, Vue, options } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import axios from "axios";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";
import PatientVisit from "@/models/patientEMRs/PatientVisit";

@Component({
  props: ["MyVstdate", "MyHn", "MyCid", "MySearchStatus"],
  component: {
    store,
    axios,
    thaiDatetime,
    pjFunctions,
    PatientVisit
  },
  data() {
    return {
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      lang: {
        // days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        days: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
        months: [
          "ม.ค",
          "ก.พ",
          "มี.ค",
          "เม.ย",
          "พ.ค",
          "มิ.ย",
          "ก.ค",
          "ส.ค",
          "ก.ย",
          "ต.ค",
          "พ.ย",
          "ธ.ค"
        ],
        // months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        pickers: ["next 1 days", "previous 1 days"],
        placeholder: {
          date: "Select Date",
          dateRange: "Select Date Range"
        },
        MyScanDate: this.MyScanDate,
        MyHn: this.MyHn,
        MyScanType: this.MyScanType
      },
      FilesScanDataLoad: [],
      tbTableData: null,
      tbTableFieldsData: null,
      sortBy: "numbers",
      sortDesc: true
    };
  },
  mounted() {},
  created() {
    this.thaiDatetimeFc = thaiDatetime.methods;
    this.pjFunctionsFc = pjFunctions.methods;
  },
  watch: {
    MySearchStatus: function() {
      if (this.MySearchStatus == true) {
        this.loadVisitData(this.MyHn, this.MyCid, this.MyVstdate);
      }
    }
  },
  methods: {
    show(group, type = "", title = "", text = "") {
      this.$notify({
        group,
        title: title,
        text: text,
        type,
        data: {
          randomNumber: Math.random()
        }
      });
    },
    clean(group) {
      this.$notify({ group, clean: true });
    },
    loadVisitData(hn, cid, vstdate) {
      store.set("systems@SpinnersShow", true);

      let data = [];
      let VisitObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "VisitOPD", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
          cid: cid,
          vstdate: vstdate
        })
        .then(function(response) {
          VisitObj.output = response.data;
          if (VisitObj.output.status === true) {
            PatientVisit.delete({
              where(record) {
                return record.hn == hn;
              }
            });

            data = [];
            let dtID = 0;
            for (var val of VisitObj.output.result) {
              if (
                val.vstdate != "" &&
                val.vstdate != "null" &&
                val.vstdate != null &&
                val.vsttime != "" &&
                val.vsttime != "null" &&
                val.vsttime != null
              ) {
                dtID = VisitObj.thaiDatetimeFc.DateTimeId(
                  val.vstdate + " " + val.vsttime
                );
              }

              data.push({
                id: val.vn,
                hn: val.hn,
                datas: val,
                visit_orderby: dtID
              });
            }

            PatientVisit.insertOrUpdate({
              data
            });
          } else {
            if (VisitObj.output.ErrorMessage === "Data Not Found") {
              store.set("systems@SpinnersShow", false);
              PatientVisit.delete({
                where(record) {
                  return record.hn == hn;
                }
              });
            }
          }
        })
        .catch(function(error) {
          VisitObj.output = error;
          console.log("VisitOPD : " + VisitObj.output);
        })
        .finally(function() {
          store.set("systems@SpinnersShow", false);
          if (VisitObj.output.status !== true) {
            alert("ไม่พบ Visit ของผู้ป้วย !");
          } else {
            VisitObj.getVisitDatasTable(hn, cid, vstdate);
          }
        });
    },
    getVisitDatasTable(hn, cid, vstdate) {
      let DataObj = null;

      if (cid != "") {
        DataObj = PatientVisit.query()
          .where(record => record.datas.cid == cid)
          .get();
      } else {
        DataObj = PatientVisit.query()
          .where(record => record.hn == hn)
          .get();
      }

      let TableData = [];

      let i = 0;

      for (var val of DataObj) {
        i = i + 1;
        TableData.push({
          numbers: i,
          hn: val.hn,
          vstdate: this.thaiDatetimeFc.ThaiDateTime(
            val.datas.vstdate + " " + val.datas.vsttime
          ),
          cid: val.datas.cid,
          fullName: val.datas.pname + val.datas.fname + " " + val.datas.lname,
          department_code: val.datas.department_code,
          department_name: val.datas.department_name,
          birthday: this.thaiDatetimeFc.ThaiDate(val.datas.birthday),
          ageFull:
            val.datas.age_y +
            " ปี" +
            val.datas.age_m +
            " เดือน" +
            val.datas.age_d +
            " วัน",
          pttype_name: val.datas.pttype_name,
          action: ""
        });
      }

      let TableFieldsData = [
        { label: "ลำดับ", key: "numbers", sortable: true, class: "text-right" },
        { label: "วันที่", key: "vstdate", sortable: true },
        { label: "ห้องตรวจ", key: "department_name", sortable: true },
        { label: "CID", key: "cid", sortable: true },
        { label: "HN", key: "hn", sortable: true },
        { label: "ชื่อ - สกุล", key: "fullName", sortable: true },
        { label: "วันเกิด", key: "birthday", sortable: true },
        { label: "อายุ", key: "ageFull", sortable: true },
        { label: "สิทธิการรักษา", key: "pttype_name", sortable: true },
        { label: "Action", key: "action", sortable: true }
      ];

      if (DataObj.length > 0) {
        this.tbTableData = TableData;
        this.tbTableFieldsData = TableFieldsData;
      } else {
        this.tbTableData = null;
        this.tbTableFieldsData = null;
      }
    }
  }
})
export default class EverReferVisitData extends Vue {}
</script>


<style lang="scss">
</style>
